// removed by extract-text-webpack-plugin
module.exports = {"main":"a_b","mainOffset":"a_c a_b","whiteBg":"a_e"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/Layout/styles.module.css
// module id = 1134
// module chunks = 27